var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-main",
    { staticClass: "pa-2 report_detail pcksgreport", attrs: { fluid: "" } },
    [
      _c(
        "v-row",
        [
          _c(
            "v-col",
            { attrs: { cols: "12", md: "6" } },
            [
              _c("v-text-field", {
                attrs: {
                  "append-icon": "mdi-filter",
                  label: "Type to filter Purchases"
                },
                model: {
                  value: _vm.filter,
                  callback: function($$v) {
                    _vm.filter = $$v
                  },
                  expression: "filter"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-col",
            { attrs: { cols: "12", md: "6" } },
            [
              _c("RangePicker", {
                attrs: { range: this.getCurrentMonth() },
                on: { reloadData: _vm.loadData }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-row",
        [
          _c(
            "v-col",
            { attrs: { cols: "12" } },
            [
              _c("v-data-table", {
                attrs: {
                  search: _vm.filter,
                  headers: _vm.headers,
                  items: _vm.resources_logs,
                  "item-key": "id",
                  "items-per-page": 30
                },
                scopedSlots: _vm._u([
                  {
                    key: "item.checkDate",
                    fn: function(ref) {
                      var item = ref.item
                      return [
                        _vm._v(
                          "\n                  " +
                            _vm._s(
                              new Date(item.checkDate).toLocaleString("en-AU", {
                                timeZone: "UTC",
                                weekday: "short",
                                year: "numeric",
                                month: "short",
                                day: "numeric"
                              })
                            ) +
                            "\n              "
                        )
                      ]
                    }
                  },
                  {
                    key: "item.qty",
                    fn: function(ref) {
                      var item = ref.item
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(item.qty) + " " + _vm._s(item.resource.unit)
                          )
                        ])
                      ]
                    }
                  }
                ])
              }),
              _vm._v("\n          Merch Purchases coming soon\n        ")
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }